/** Vite `base` — luôn kết thúc bằng `/` (vd `/` hoặc `/eduquiz-kid-site/`) */
export const VITE_BASE_URL = import.meta.env.BASE_URL;

/**
 * Basename cho React Router (không có slash cuối). GitHub Pages project: `/eduquiz-kid-site`.
 */
export function getRouterBasename() {
  const b = String(VITE_BASE_URL || '/').replace(/\/$/, '');
  return b || undefined;
}

/**
 * URL đầy đủ để chia sẻ (origin + base + path). `pathname` bắt đầu bằng `/`.
 */
export function getAbsoluteAppUrl(pathname) {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const base = String(VITE_BASE_URL || '/').replace(/\/$/, '');
  return `${window.location.origin}${base}${path}`;
}
